import { render, staticRenderFns } from "./CreateInteractionTemplateDialog.vue?vue&type=template&id=373804bb&scoped=true"
import script from "./CreateInteractionTemplateDialog.vue?vue&type=script&lang=js"
export * from "./CreateInteractionTemplateDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateInteractionTemplateDialog.vue?vue&type=style&index=0&id=373804bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373804bb",
  null
  
)

export default component.exports